"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Repulser = void 0;

var Enums_1 = require("../../../../Enums");

var Utils_1 = require("../../../../Utils");

var Repulser = /*#__PURE__*/function () {
  function Repulser(container) {
    _classCallCheck(this, Repulser);

    this.container = container;
  }

  _createClass(Repulser, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container;
      var options = container.options;
      var mouse = container.interactivity.mouse;
      var events = options.interactivity.events;
      var divs = events.onDiv;
      var divRepulse = Utils_1.Utils.isDivModeEnabled(Enums_1.DivMode.repulse, divs);

      if (!(divRepulse || events.onHover.enable && mouse.position || events.onClick.enable && mouse.clickPosition)) {
        return false;
      }

      var hoverMode = events.onHover.mode;
      var clickMode = events.onClick.mode;
      return Utils_1.Utils.isInArray(Enums_1.HoverMode.repulse, hoverMode) || Utils_1.Utils.isInArray(Enums_1.ClickMode.repulse, clickMode) || divRepulse;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact() {
      var _this = this;

      var container = this.container;
      var options = container.options;
      var mouseMoveStatus = container.interactivity.status === Utils_1.Constants.mouseMoveEvent;
      var events = options.interactivity.events;
      var hoverEnabled = events.onHover.enable;
      var hoverMode = events.onHover.mode;
      var clickEnabled = events.onClick.enable;
      var clickMode = events.onClick.mode;
      var divs = events.onDiv;

      if (mouseMoveStatus && hoverEnabled && Utils_1.Utils.isInArray(Enums_1.HoverMode.repulse, hoverMode)) {
        this.hoverRepulse();
      } else if (clickEnabled && Utils_1.Utils.isInArray(Enums_1.ClickMode.repulse, clickMode)) {
        this.clickRepulse();
      } else {
        Utils_1.Utils.divModeExecute(Enums_1.DivMode.repulse, divs, function (id, div) {
          return _this.singleDivRepulse(id, div);
        });
      }
    }
  }, {
    key: "singleDivRepulse",
    value: function singleDivRepulse(id, div) {
      var container = this.container;
      var elem = document.getElementById(id);

      if (!elem) {
        return;
      }

      var pxRatio = container.retina.pixelRatio;
      var pos = {
        x: (elem.offsetLeft + elem.offsetWidth / 2) * pxRatio,
        y: (elem.offsetTop + elem.offsetHeight / 2) * pxRatio
      };
      var repulseRadius = elem.offsetWidth / 2 * pxRatio;
      var area = div.type === Enums_1.DivType.circle ? new Utils_1.Circle(pos.x, pos.y, repulseRadius) : new Utils_1.Rectangle(elem.offsetLeft * pxRatio, elem.offsetTop * pxRatio, elem.offsetWidth * pxRatio, elem.offsetHeight * pxRatio);
      var divs = container.options.interactivity.modes.repulse.divs;
      var divRepulse = Utils_1.Utils.divMode(divs, id);
      this.processRepulse(pos, repulseRadius, area, divRepulse);
    }
  }, {
    key: "hoverRepulse",
    value: function hoverRepulse() {
      var container = this.container;
      var mousePos = container.interactivity.mouse.position;

      if (!mousePos) {
        return;
      }

      var repulseRadius = container.retina.repulseModeDistance;
      this.processRepulse(mousePos, repulseRadius, new Utils_1.Circle(mousePos.x, mousePos.y, repulseRadius));
    }
  }, {
    key: "processRepulse",
    value: function processRepulse(position, repulseRadius, area, divRepulse) {
      var _a;

      var container = this.container;
      var query = container.particles.quadTree.query(area);

      var _iterator = _createForOfIteratorHelper(query),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var particle = _step.value;

          var _Utils_1$Utils$getDis = Utils_1.Utils.getDistances(particle.position, position),
              dx = _Utils_1$Utils$getDis.dx,
              dy = _Utils_1$Utils$getDis.dy,
              distance = _Utils_1$Utils$getDis.distance;

          var normVec = {
            x: dx / distance,
            y: dy / distance
          };
          var velocity = ((_a = divRepulse === null || divRepulse === void 0 ? void 0 : divRepulse.speed) !== null && _a !== void 0 ? _a : container.options.interactivity.modes.repulse.speed) * 100;
          var repulseFactor = Utils_1.Utils.clamp((1 - Math.pow(distance / repulseRadius, 2)) * velocity, 0, 50);
          particle.position.x = particle.position.x + normVec.x * repulseFactor;
          particle.position.y = particle.position.y + normVec.y * repulseFactor;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "clickRepulse",
    value: function clickRepulse() {
      var container = this.container;

      if (!container.repulse.finish) {
        if (!container.repulse.count) {
          container.repulse.count = 0;
        }

        container.repulse.count++;

        if (container.repulse.count === container.particles.count) {
          container.repulse.finish = true;
        }
      }

      if (container.repulse.clicking) {
        var repulseDistance = container.retina.repulseModeDistance;
        var repulseRadius = Math.pow(repulseDistance / 6, 3);
        var mouseClickPos = container.interactivity.mouse.clickPosition;

        if (mouseClickPos === undefined) {
          return;
        }

        var range = new Utils_1.Circle(mouseClickPos.x, mouseClickPos.y, repulseRadius);
        var query = container.particles.quadTree.query(range);

        var _iterator2 = _createForOfIteratorHelper(query),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var particle = _step2.value;

            var _Utils_1$Utils$getDis2 = Utils_1.Utils.getDistances(mouseClickPos, particle.position),
                dx = _Utils_1$Utils$getDis2.dx,
                dy = _Utils_1$Utils$getDis2.dy,
                distance = _Utils_1$Utils$getDis2.distance;

            var d = distance * distance;
            var velocity = container.options.interactivity.modes.repulse.speed;
            var force = -repulseRadius * velocity / d;

            if (d <= repulseRadius) {
              container.repulse.particles.push(particle);
              var angle = Math.atan2(dy, dx);
              particle.velocity.horizontal = force * Math.cos(angle);
              particle.velocity.vertical = force * Math.sin(angle);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else if (container.repulse.clicking === false) {
        var _iterator3 = _createForOfIteratorHelper(container.repulse.particles),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _particle = _step3.value;
            _particle.velocity.horizontal = _particle.initialVelocity.horizontal;
            _particle.velocity.vertical = _particle.initialVelocity.vertical;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        container.repulse.particles = [];
      }
    }
  }]);

  return Repulser;
}();

exports.Repulser = Repulser;